import Vue from 'vue'

// 为数字添加符号
Vue.filter('sign', value => {
  const n = parseFloat(value)
  return !n || n < 0 ? value : `+${value}`
})
